import { render, staticRenderFns } from "./BlubberThreadWidget.vue?vue&type=template&id=2331ddae&"
import script from "./BlubberThreadWidget.vue?vue&type=script&lang=js&"
export * from "./BlubberThreadWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2331ddae')) {
      api.createRecord('2331ddae', component.options)
    } else {
      api.reload('2331ddae', component.options)
    }
    module.hot.accept("./BlubberThreadWidget.vue?vue&type=template&id=2331ddae&", function () {
      api.rerender('2331ddae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/BlubberThreadWidget.vue"
export default component.exports